import script from "./Parameters.vue?vue&type=script&setup=true&lang=ts"
export * from "./Parameters.vue?vue&type=script&setup=true&lang=ts"

import "./Parameters.vue?vue&type=style&index=0&id=138e2ce7&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-138e2ce7"]])

export default __exports__